import { CacheableDataObject } from 'models/CacheableDataObject.jsx';
import { Users } from "models/UserCollection.jsx";

export class MatchDolphinStatus extends CacheableDataObject {
	beforeConstruct() {
		this.registeredPlayers = new Set();
		this.registeredSlots = new Set();
	}

	getPlayerAtSlot(slotNumber) {
		return this.players[slotNumber] ? this.players[slotNumber].player : null;
	}

	playerHasASlot(player) {
		return this.registeredPlayers.has(player);
	}

	allSlotsAreFine(){
		return this.registeredPlayers.size > 0 && _.size(this.players) === this.registeredPlayers.size;
	}

}

MatchDolphinStatus.prototype.dataLocationParsers = {
	players(dolphin, data) {
		dolphin.players = {};
		dolphin.registeredPlayers.clear();
		dolphin.registeredSlots.clear();
		for(let i in data.players) {
			if(!data.players.hasOwnProperty(i)) {
				continue;
			}
			const slotPlayer = DolphinSlotPlayer.create(data.players[i]);
			dolphin.players[i] = slotPlayer;
			if(slotPlayer.player) {
				dolphin.registeredPlayers.add(slotPlayer.player);
			}
		}
	}
};

class DolphinSlotPlayer extends CacheableDataObject {

}

DolphinSlotPlayer.prototype.dataLocationParsers = {
	slot(player, data) {
		player.slot = Number.parseInt(data.slot);
	},
	player(player, data) {
		player.player = Users.update(data.player);
	}
};
